import React from "react";
import { NavLink } from "react-router-dom";
// import * as ROUTES from '../../constants/routes';
import SignedOutLinks from "./SignedOutLinks";
import SignedInLinks from "./SignedInLinks";
import DashboardSidebar from "../dashboard/layout/DashboardSidebar";
import { connect } from 'react-redux';

const Navbar = (props) => {
    const { backgroundColor, themeColor, themeColorNav, appTitle } = props.theme;

    const { isSignedIn, isEmailVerified, userData,appControl } = props;
    const {isTestApp} = appControl;
    const signedInTopLinks = isSignedIn ? (isEmailVerified ? <SignedInLinks /> : <React.Fragment />) : (<SignedOutLinks />);
    const signedInSidebar = userData.isLoaded && isSignedIn && isEmailVerified ? <DashboardSidebar /> : <React.Fragment />;
    const navbarStyle = isSignedIn ? ({
        background: themeColorNav,
        padding: '0px',
    }) : ({
        background: themeColorNav,
    });
    const navbarClassName = isSignedIn ? "navbar fixed-top navbar-expand-md navbar-dark" : "navbar fixed-top navbar-expand-md navbar-dark";

    return (

        <div>
            <nav className={navbarClassName} style={navbarStyle}>
                <NavLink className="navbar-brand pl-3" to="/">
                    <span className="d-inline-block align-top icon icon-app" />
                    <span>{appTitle}{isTestApp?`(dev)`:''}</span>
                </NavLink>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon small" />
                </button>
                <div className="vl-topbar" />
                {signedInTopLinks}
            </nav>
            {/* SHOW ONLY IF SIGNED IN */}
            {signedInSidebar}
        </div>
    );
}

const mapStateToProps = (state) => {
    // console.log(state.firebase)
    return {
        isEmailVerified: state.firebase.auth.emailVerified,
        isSignedIn: !state.firebase.auth.isEmpty,
        userData: state.firebase.profile,
        theme: state.theme,
        appControl: state.appControl,
    }
}

export default connect(mapStateToProps)(Navbar);
